import { render, staticRenderFns } from "./TaskWorkChat.vue?vue&type=template&id=70471e0b&scoped=true&"
import script from "./TaskWorkChat.vue?vue&type=script&lang=js&"
export * from "./TaskWorkChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskWorkChat.vue?vue&type=style&index=0&id=70471e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70471e0b",
  null
  
)

export default component.exports